import makeStyles from "@mui/styles/makeStyles";
import { Link, LinkProps } from "@mui/material";
import { push } from "connected-react-router";
import { MouseEvent } from "react";
import * as React from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import _ from "lodash";
import classNames from "classnames";

interface NavLinkProps extends LinkProps {
    to?: string;
    redirectState?: { from?: string; params?: string };
    additionalOnClick?: (ev: React.MouseEvent<any>) => void;
    children: React.ReactNode;
    stopPropagation?: boolean;
    disabled?: boolean;
    target?: React.HTMLAttributeAnchorTarget | undefined;
}

const useStyles = makeStyles((theme) => ({
    disabled: {
        pointerEvents: "none",
        cursor: "default",
        color: theme.palette.grey300,
    },
}));

export const NavLink = (props: NavLinkProps) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const {
        to,
        redirectState,
        additionalOnClick = () => null,
        children,
        stopPropagation,
        disabled = false,
        target,
        ...others
    } = props;

    const onClick = (ev: MouseEvent) => {
        if (!to) {
            return;
        }

        if (!to.startsWith("http") && !to.includes("://")) {
            ev.preventDefault();
            dispatch(push(to, redirectState));
        }

        if (stopPropagation) {
            ev.stopPropagation();
        }

        additionalOnClick(ev);
    };

    return (
        <Link
            className={classNames({
                [classes.disabled]: disabled,
            })}
            href={to}
            onClick={onClick}
            target={target}
            children={children}
            {...others}
        />
    );
};
